import { useDisclosure } from "@chakra-ui/hooks";
import styled from "@emotion/styled";
import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { billingAtom, newBillingAtom } from "../../../../../atoms/BillingAtom";
import VideoUsersModal from "../../../../Settings/Modal/VideoUsersModal";
import {
  ActivateAccountContainer,
  ActivateLeftContainer,
  ActivationSubtitle,
  ActivationTitle,
  CardAdditionalContainer,
  DollarSign,
  InputQuantity,
  Price,
  PurchaseAdditionalTitle,
  PurchaseContainer,
  SectionTitle,
  TotalAmountContainer,
  TotalAmountContent,
} from "./PaymentModalStyles";

export const numberToExpression = [
  "a",
  "a",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];

export const numberToString = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];

interface IActivateLeft {
  customTitle?: string;
}

const UsersExplainLink = styled.div`
  cursor: pointer;
  color: #fb972e;
  width: fit-content;
  font-size: 15px;
  font-family: "Source Sans Pro";
  font-weight: 600;
  margin-top: 2px;
`;

export default function ActivateLeft(props: IActivateLeft): JSX.Element {
  const { customTitle } = props;

  const oldBilling = useRecoilValue(billingAtom);
  const [billing, setBilling] = useRecoilState(newBillingAtom);
  const { isOpen, onClose, onOpen } = useDisclosure();

  useEffect(() => {
    setBilling({ externalUsers: 0, admins: 0, ...oldBilling });
  }, [oldBilling]);

  function handleAdminChange(value: number) {
    setBilling((oldBil) => ({
      ...oldBil,
      admins: value > oldBil.initialAdmins ? value : oldBil.initialAdmins,
    }));
  }

  function handleExternalUsersChange(value: number) {
    setBilling((oldBil) => ({
      ...oldBil,
      externalUsers:
        value > oldBil.initialExternalAdmins
          ? value
          : oldBil.initialExternalAdmins,
    }));
  }

  return (
    <>
      <ActivateLeftContainer>
        <ActivateAccountContainer>
          <ActivationTitle>
            {customTitle ? customTitle : "Purchase additional users"}
          </ActivationTitle>
          <ActivationSubtitle>Update your subscription!</ActivationSubtitle>
        </ActivateAccountContainer>
        <PurchaseContainer>
          <PurchaseAdditionalTitle>
            Purchase Additional Internal Users{" "}
            <UsersExplainLink
              onClick={() => {
                onOpen();
              }}
            >
              What's the difference between Internal & External users?
            </UsersExplainLink>
          </PurchaseAdditionalTitle>
          <CardAdditionalContainer>
            <div>
              Price
              <p>${billing.adminPrice || "--"}</p>
            </div>
            <div style={{ width: 50 }}>
              Quantity
              <InputQuantity
                type="number"
                value={billing.admins || 0}
                onChange={(event) =>
                  handleAdminChange(event.target.valueAsNumber)
                }
                max="1000000"
                min={0}
              />
            </div>
            <div>
              Aditional Price
              <p>${(billing.adminPrice || 0) * billing.admins}</p>
            </div>
          </CardAdditionalContainer>
        </PurchaseContainer>
        <PurchaseContainer>
          <PurchaseAdditionalTitle>
            Purchase Additional External Users{" "}
            <UsersExplainLink
              onClick={() => {
                onOpen();
              }}
            >
              What's the difference between Internal & External users?
            </UsersExplainLink>
          </PurchaseAdditionalTitle>
          <CardAdditionalContainer>
            <div>
              Price
              <p>${billing.externalUserPrice || "--"}</p>
            </div>
            <div style={{ width: 50 }}>
              Quantity
              <InputQuantity
                type="number"
                value={billing.externalUsers || 0}
                onChange={(event) =>
                  handleExternalUsersChange(event.target.valueAsNumber)
                }
                max="1000000"
                min={0}
              />
            </div>
            <div>
              Aditional Price
              <p>${(billing.externalUserPrice || 0) * billing.externalUsers}</p>
            </div>
          </CardAdditionalContainer>
        </PurchaseContainer>
        <div>
          <SectionTitle>Total Amount</SectionTitle>
          <TotalAmountContainer>
            <TotalAmountContent>
              <div>Billed monthly</div>
              <Price>
                <DollarSign>$</DollarSign>
                {billing.oldPrice / 100 +
                  (billing.admins - billing.initialAdmins) *
                    billing.adminPrice +
                  (billing.externalUsers - billing.initialExternalAdmins) *
                    billing.externalUserPrice || "--"}
                <span>/ mo</span>
              </Price>
            </TotalAmountContent>
          </TotalAmountContainer>
        </div>
      </ActivateLeftContainer>
      <VideoUsersModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
